import VTooltip from "v-tooltip"

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.use(VTooltip)
})
